/* eslint-disable react/prop-types */
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";

import MDButton from "components/MDButton";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default function DisconnectModal({ open, handleClose, onSumbit = () => {}, data = {} }) {
  return open ? (
    <BootstrapDialog aria-labelledby="customized-dialog-title" open={open}>
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        Disconnect devicee
      </BootstrapDialogTitle>
      <DialogContent dividers>
        Are you sure you want to disconnect device <b>{data.description}</b> from phsical device{" "}
        <b>{data.deviceMacAddress}</b>
      </DialogContent>

      <DialogActions>
        <MDButton onClick={handleClose} type="button" variant="gradient" color="secondary">
          Cancel
        </MDButton>
        <MDButton onClick={onSumbit} variant="gradient" color="info">
          Disconnect
        </MDButton>
      </DialogActions>
    </BootstrapDialog>
  ) : null;
}
